export interface ExpiryLedgerTie {
  account: string;
  movementMinor: number;
  fromStockMovementsMinor: number;
  otherPostingsMinor: number;
  sources: { source: string; netDebitMinor: number }[];
}

export const LEDGER_NOT_SHOWN_FOR_STORE =
  'The ledger figure is for the whole hospital, so it is not shown while a single store is picked.';

export function ledgerTieLine(ledger: ExpiryLedgerTie | null, format: (minor: number) => string): string {
  if (ledger === null) return LEDGER_NOT_SHOWN_FOR_STORE;
  const tie = `Ties to ledger account ${ledger.account}: ${format(ledger.movementMinor)}`;
  if (ledger.otherPostingsMinor === 0) return `${tie}.`;
  return (
    `${tie}. Stock movements explain ${format(ledger.fromStockMovementsMinor)}; ` +
    `the difference of ${format(ledger.otherPostingsMinor)} is other postings and rounding.`
  );
}

export interface InputVatParts {
  receivedTaxMinor: number;
  returnedTaxMinor: number;
  voidedTaxMinor: number;
}

export function netInputTaxMinor(parts: InputVatParts): number {
  return parts.receivedTaxMinor - parts.returnedTaxMinor - parts.voidedTaxMinor;
}

export interface VatRateFigures {
  rate: number;
  taxableMinor: number;
  taxMinor: number;
  documents: number;
}

export function voidedFigureAt(voided: readonly VatRateFigures[] | undefined, rate: number): VatRateFigures | undefined {
  return voided?.find((row) => row.rate === rate);
}

export function allInputRates(...lists: (readonly VatRateFigures[] | undefined)[]): number[] {
  return [...new Set(lists.flatMap((list) => (list ?? []).map((row) => row.rate)))].sort((a, b) => a - b);
}
